module.exports = __webpack_public_path__ + "static/scout_logo-055e44925ef07224a89a20dd317c763f.png";